import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";

interface ICreateNoteInViewProps {
    addNoteOperation: number;
    hideControlOperation: number;
    hideControlCallback?: () => void;
    addNoteCallback?: (note: string) => void;
    maxHeight?: string;
    showFullWidth?: boolean;
    extraButtons?: ((state: CreateNoteInViewState) => JSX.Element)[];
}

class CreateNoteInViewState {
    public note: string;
    public formLocked: boolean;

    constructor(s?: Partial<CreateNoteInViewState>) {
        Object.assign(this, s);
    }

    public static default(): CreateNoteInViewState {
        return new CreateNoteInViewState({
            note: "",
            formLocked: false
        });
    }
}

class CreateNoteInView extends BaseReactComponent<ICreateNoteInViewProps, CreateNoteInViewState> {
    private textAreaId: string;

    public constructor(props: ICreateNoteInViewProps) {
        super(props);
        this.state = CreateNoteInViewState.default();
        this.textAreaId = GuidHelper.NewGuid();
    }

    public render(): JSX.Element {
        const textAreaWrapperClassName = this.props.showFullWidth ? "full-Width" : "in-view-note-write-container";
        const isEmpty = $.trim(this.state.note).length === 0;

        let style: React.CSSProperties = !IsNullOrWhiteSpace(this.props.maxHeight)
            ? { maxHeight: this.props.maxHeight }
            : {};

        return (
            <div className={textAreaWrapperClassName} data-cy="createNoteInView">
                <div className="row">
                    <textarea
                        style={style}
                        id={this.textAreaId}
                        data-cy="createNoteInView-note"
                        className="form-control"
                        disabled={this.state.formLocked}
                        rows={2}
                        value={this.state.note}
                        onChange={e => {
                            const value = e.target.value;
                            this.mutateState(s => s.note = value);
                        }}
                    />
                </div>
                <div className="row native">
                    <button
                        disabled={this.state.formLocked}
                        className="btn btn-default btn-sm"
                        style={{ marginRight: "5px" }}
                        data-cy="createNoteInView-cancel"
                        onClick={() => this.onCancelClick()}
                    >
                        {cacheStore.GetString("CancelLabel")}
                    </button>
                    <button
                        disabled={this.state.formLocked || isEmpty}
                        className="btn btn-primary btn-sm"
                        data-cy="createNoteInView-save"
                        onClick={() => this.onSaveClick()}
                    >
                        {cacheStore.GetString("SaveLabel")}
                    </button>
                    {this.props?.extraButtons?.map(func => func(this.state))}
                </div>

            </div>
        );
    }

    public componentDidMount(): void {
        autosize(document.getElementById(this.textAreaId));
    }

    public componentWillUnmount(): void {
        const el = document.getElementById(this.textAreaId);
        const evt = document.createEvent("Event");
        evt.initEvent("autosize:destroy", true, false);
        el.dispatchEvent(evt);
    }

    private onSaveClick(): void {
        if ($.trim(this.state.note).length === 0) return;

        this.mutateState(s => s.formLocked = true, () => {
            this.props.addNoteOperation && sessionStore.dispatch(this.props.addNoteOperation, { value: this.state.note });
            this.props.addNoteCallback?.(this.state.note);
        });
    }

    private onCancelClick(): void {
        this.props.hideControlOperation && sessionStore.dispatch(this.props.hideControlOperation);
        this.props.hideControlCallback?.();
    }
}

export { CreateNoteInView };
